import { render, staticRenderFns } from "./OrdemDeServicoAberturaEdicaoView.vue?vue&type=template&id=92253608&scoped=true"
import script from "./OrdemDeServicoAberturaEdicaoView.vue?vue&type=script&lang=js"
export * from "./OrdemDeServicoAberturaEdicaoView.vue?vue&type=script&lang=js"
import style0 from "./OrdemDeServicoAberturaEdicaoView.vue?vue&type=style&index=0&id=92253608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92253608",
  null
  
)

export default component.exports